import React from "react";
import "./WhatsApp.css";
import whatsapp from "../images/whatsapp.png";

const WhatsApp = () => {
  return (
    <div className="whatsapp">
      <a href="https://wa.me/76878378?text=Hello%20there%20!%20I%20would%20like%20some%20details%20about%20the%20cross%20country%20flight.">
        <span className="pill-text">WhatsApp Us</span>
        <img src={whatsapp} alt="WhatsApp Icon" />
      </a>
    </div>
  );
};

export default WhatsApp;
